import React from 'react';
import PropTypes from 'prop-types';

const InputRadio = ({ inline = false, id, value, label, error, ...props }) => {
	return (
		<div className={`form-check ${inline && 'form-check-inline'}`}>
			<input className='form-check-input' type='radio' value={value} id={id} {...props} />
			{label && (
				<label className='form-check-label' htmlFor={id}>
					{label}
				</label>
			)}
			{error && error.message && <div className='invalid-feedback d-block'>{error.message}</div>}
		</div>
	);
};

InputRadio.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	error: PropTypes.object,
	label: PropTypes.string,
	inline: PropTypes.bool,
	value: PropTypes.any
};
export default InputRadio;
